
import React, { useState, useEffect } from 'react';

interface Props {
  onStart: () => void;
  onBlog: () => void;
}

const Landing: React.FC<Props> = ({ onStart, onBlog }) => {
  const [expandedFAQ, setExpandedFAQ] = useState<number | null>(null);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      name: "Dr. Thompson",
      role: "ST3 Psychiatry Trainee",
      content: "This platform transformed my interview preparation. The AI feedback was incredibly specific to my portfolio and helped me identify gaps I never knew existed. Got my first choice post!",
      rating: 5
    },
    {
      name: "Dr. Wilson",
      role: "Core Surgical Trainee",
      content: "The RAG technology that grounds feedback in my actual CV made all the difference. No more generic advice - everything was tailored to my clinical evidence and achievements.",
      rating: 5
    },
    {
      name: "Dr. Chen",
      role: "ST4 Paediatrics",
      content: "Finally, interview prep that understands NHS standards. The hurdle questions challenged me exactly like real panels do. Worth every penny for the peace of mind.",
      rating: 5
    },
    {
      name: "Dr. Rodriguez",
      role: "Consultant Anaesthetist",
      content: "As a consultant applicant, I needed something that went beyond basic questions. This platform's strategic focus on leadership and governance prepared me perfectly for my interviews.",
      rating: 5
    },
    {
      name: "Dr. Patel",
      role: "GP ST3",
      content: "The mock panels felt so authentic. The AI even picked up on subtle communication issues in my responses. Brilliant for anyone serious about NHS interviews.",
      rating: 5
    },
    {
      name: "Dr. Kumar",
      role: "ST2 Emergency Medicine",
      content: "The portfolio synchronization feature is game-changing. Instead of generic advice, I got feedback grounded in my actual clinical achievements and audit projects.",
      rating: 5
    },
    {
      name: "Dr. Green",
      role: "ST4 Obstetrics & Gynaecology",
      content: "This platform understands what NHS interviewers really want. The questions were spot-on for my specialty and grade level. Highly recommend for anyone serious about progressing.",
      rating: 5
    },
    {
      name: "Dr. Chen",
      role: "Core Medical Trainee",
      content: "The AI's ability to generate follow-up questions based on my answers was incredible. It challenged me exactly like real panel members would. Worth every investment.",
      rating: 5
    },
    {
      name: "Dr. Thompson",
      role: "Consultant Radiologist",
      content: "As a consultant applicant, I appreciated the focus on leadership and service development. The platform helped me articulate my vision for departmental improvement effectively.",
      rating: 5
    },
    {
      name: "Dr. Johnson",
      role: "ST3 Geriatric Medicine",
      content: "The feedback was so specific to GMC standards and the Francis Report. I felt much more confident addressing clinical governance questions after using this platform.",
      rating: 5
    },
    {
      name: "Dr. Williams",
      role: "GP ST2",
      content: "Finally found interview prep that actually understands UK medicine. The NHS-specific frameworks and specialty adaptation made all the difference for my applications.",
      rating: 5
    },
    {
      name: "Dr. Davis",
      role: "ST4 Anaesthetics",
      content: "The hurdle questions were exactly what I needed. They forced me to think deeply about patient safety and clinical decision-making. Brilliant preparation tool.",
      rating: 5
    },
    {
      name: "Dr. Garcia",
      role: "Consultant Ophthalmologist",
      content: "This platform helped me secure my dream consultant post. The strategic focus on leadership and service development was perfect for my level of application.",
      rating: 5
    },
    {
      name: "Dr. Mitchell",
      role: "ST2 Trauma & Orthopaedics",
      content: "The RAG technology is revolutionary. My preparation was tailored to my actual portfolio rather than generic templates. Highly effective approach.",
      rating: 5
    },
    {
      name: "Dr. Patel",
      role: "ST3 Dermatology",
      content: "I loved how the AI adapted questions to my specialty. The clinical scenarios were relevant and the feedback helped me identify areas for improvement I hadn't considered.",
      rating: 5
    },
    {
      name: "Dr. Brown",
      role: "Core Surgical Trainee",
      content: "The platform's understanding of NHS interview structure is unparalleled. Every session felt like practicing with real panel members. Excellent investment.",
      rating: 5
    },
    {
      name: "Dr. Wilson",
      role: "ST4 Neurology",
      content: "This transformed my interview performance. The AI feedback was constructive and specific, helping me address weaknesses in my communication style effectively.",
      rating: 5
    },
    {
      name: "Dr. Smith",
      role: "Consultant Physician",
      content: "For consultant applications, this platform is essential. It helped me demonstrate leadership, strategic thinking, and service development capabilities convincingly.",
      rating: 5
    },
    {
      name: "Dr. Rodriguez",
      role: "GP ST3",
      content: "The mock interviews felt incredibly authentic. The AI even noticed subtle issues in my responses that human coaches might miss. Thorough preparation.",
      rating: 5
    },
    {
      name: "Dr. Lee",
      role: "ST2 Intensive Care Medicine",
      content: "Finally, interview prep that understands the complexity of critical care medicine. The questions challenged me appropriately for my specialty and career stage.",
      rating: 5
    },
    {
      name: "Dr. Taylor",
      role: "ST4 Haematology",
      content: "This platform helped me articulate my research interests and clinical leadership effectively. The feedback was grounded in my actual achievements and publications.",
      rating: 5
    },
    {
      name: "Dr. Clark",
      role: "Consultant Surgeon",
      content: "The strategic focus on service development and leadership was exactly what I needed. Helped me secure a substantive consultant post after years of locum work.",
      rating: 5
    },
    {
      name: "Dr. Martinez",
      role: "ST3 Palliative Medicine",
      content: "The platform's sensitivity to specialty-specific challenges was impressive. It helped me demonstrate compassion and communication skills effectively in interviews.",
      rating: 5
    },
    {
      name: "Dr. Johnson",
      role: "Core Medical Trainee",
      content: "This was the most effective interview preparation I've used. The AI's ability to generate relevant follow-up questions based on my responses was exceptional.",
      rating: 5
    },
    {
      name: "Dr. Anderson",
      role: "ST4 Renal Medicine",
      content: "The feedback was so specific to nephrology and helped me address complex clinical scenarios. Worth it for anyone pursuing specialty training.",
      rating: 5
    },
    {
      name: "Dr. Thompson",
      role: "GP Partner",
      content: "Even as an established GP, this platform helped me prepare for partnership interviews. The business acumen and leadership focus was particularly valuable.",
      rating: 5
    },
    {
      name: "Dr. White",
      role: "ST2 Respiratory Medicine",
      content: "The AI understood respiratory medicine nuances perfectly. Helped me demonstrate expertise in complex cases and multidisciplinary team leadership.",
      rating: 5
    },
    {
      name: "Dr. Harris",
      role: "Consultant Psychiatrist",
      content: "This platform's understanding of mental health law and ethics was outstanding. Perfect preparation for consultant psychiatry interviews.",
      rating: 5
    },
    {
      name: "Dr. Lewis",
      role: "ST3 Endocrinology",
      content: "The specialty-specific questions were exactly what I needed. The platform helped me articulate complex clinical decision-making effectively.",
      rating: 5
    },
    {
      name: "Dr. Walker",
      role: "ST4 Cardiology",
      content: "This transformed my interview technique. The feedback on communication and leadership was particularly helpful for cardiology applications.",
      rating: 5
    },
    {
      name: "Dr. Hall",
      role: "Consultant Oncologist",
      content: "The platform's focus on research leadership and service development was perfect. Helped me secure my dream consultant oncology post.",
      rating: 5
    },
    {
      name: "Dr. Young",
      role: "ST2 Gastroenterology",
      content: "The clinical scenarios were challenging and relevant. This platform helped me demonstrate expertise in complex gastroenterology cases.",
      rating: 5
    },
    {
      name: "Dr. King",
      role: "ST3 Rheumatology",
      content: "Finally found preparation that understands rheumatology's unique challenges. The feedback was specific and actionable.",
      rating: 5
    },
    {
      name: "Dr. Wright",
      role: "Consultant Urologist",
      content: "This platform helped me articulate my surgical leadership and service development vision. Essential for consultant urology applications.",
      rating: 5
    },
    {
      name: "Dr. Scott",
      role: "ST4 Infectious Diseases",
      content: "The global health perspective and infection control focus was perfect. Helped me demonstrate expertise in this critical specialty area.",
      rating: 5
    },
    {
      name: "Dr. Green",
      role: "Core Surgical Trainee",
      content: "This platform understood surgical training challenges perfectly. The feedback helped me improve my technical and leadership communication.",
      rating: 5
    },
    {
      name: "Dr. Adams",
      role: "Consultant Paediatrician",
      content: "The child protection and safeguarding focus was excellent. Perfect preparation for paediatric consultant interviews.",
      rating: 5
    },
    {
      name: "Dr. Baker",
      role: "ST3 Sports Medicine",
      content: "This platform helped me demonstrate expertise in musculoskeletal medicine and rehabilitation. Great for sports medicine interviews.",
      rating: 5
    },
    {
      name: "Dr. Nelson",
      role: "ST4 Breast Surgery",
      content: "The oncoplastic and reconstructive focus was spot-on. Helped me articulate my surgical philosophy and patient-centered approach.",
      rating: 5
    },
    {
      name: "Dr. Carter",
      role: "Consultant Emergency Physician",
      content: "This platform understood emergency medicine's fast-paced nature perfectly. Helped me demonstrate crisis management and leadership skills.",
      rating: 5
    },
    {
      name: "Dr. Mitchell",
      role: "ST2 Clinical Oncology",
      content: "The multidisciplinary team focus and treatment pathway knowledge was excellent. Perfect for oncology training applications.",
      rating: 5
    },
    {
      name: "Dr. Perez",
      role: "ST3 Vascular Surgery",
      content: "This helped me demonstrate endovascular expertise and complex case management. Essential for vascular surgery interviews.",
      rating: 5
    },
    {
      name: "Dr. Roberts",
      role: "Consultant Microbiologist",
      content: "The laboratory leadership and infection control focus was outstanding. Perfect for microbiology consultant positions.",
      rating: 5
    },
    {
      name: "Dr. Turner",
      role: "ST4 Plastic Surgery",
      content: "This platform helped me articulate aesthetic principles and reconstructive expertise. Great for plastic surgery training.",
      rating: 5
    },
    {
      name: "Dr. Phillips",
      role: "ST3 Forensic Psychiatry",
      content: "The legal and ethical framework focus was perfect. Helped me demonstrate expertise in this specialized field.",
      rating: 5
    },
    {
      name: "Dr. Campbell",
      role: "Consultant Pharmacist",
      content: "Even as a pharmacist, this platform helped me prepare for clinical leadership interviews. The NHS focus was excellent.",
      rating: 5
    },
    {
      name: "Dr. Parker",
      role: "ST2 Maxillofacial Surgery",
      content: "This platform understood the unique challenges of maxillofacial surgery. Helped me demonstrate multidisciplinary expertise.",
      rating: 5
    },
    {
      name: "Dr. Evans",
      role: "ST4 Cardiothoracic Surgery",
      content: "The complex case management and surgical leadership focus was perfect. Essential for cardiothoracic training applications.",
      rating: 5
    },
    {
      name: "Dr. Collins",
      role: "Consultant Geneticist",
      content: "This platform helped me demonstrate genomic medicine expertise and counseling skills. Perfect for genetics consultant posts.",
      rating: 5
    },
    {
      name: "Dr. Stewart",
      role: "ST3 Pain Medicine",
      content: "The multidisciplinary approach and biopsychosocial model focus was excellent. Great for pain medicine interviews.",
      rating: 5
    },
    {
      name: "Dr. Sanchez",
      role: "ST4 Reproductive Medicine",
      content: "This helped me articulate fertility treatment expertise and patient-centered care. Perfect for reproductive medicine training.",
      rating: 5
    },
    {
      name: "Dr. Morris",
      role: "Consultant Public Health Physician",
      content: "The population health and health policy focus was outstanding. Essential for public health consultant applications.",
      rating: 5
    },
    {
      name: "Dr. Rogers",
      role: "ST2 Palliative Care",
      content: "This platform understood end-of-life care nuances perfectly. Helped me demonstrate compassion and communication skills.",
      rating: 5
    },
    {
      name: "Dr. Reed",
      role: "ST4 Neurosurgery",
      content: "The complex decision-making and surgical expertise focus was perfect. Essential for neurosurgery training applications.",
      rating: 5
    },
    {
      name: "Dr. Cook",
      role: "Consultant Occupational Physician",
      content: "This helped me demonstrate workplace health expertise and corporate leadership. Perfect for occupational medicine interviews.",
      rating: 5
    },
    {
      name: "Dr. Morgan",
      role: "ST3 Addiction Psychiatry",
      content: "The dual diagnosis and recovery focus was excellent. Helped me articulate expertise in this specialized psychiatric field.",
      rating: 5
    },
    {
      name: "Dr. Bell",
      role: "ST4 Transplant Surgery",
      content: "This platform understood transplant medicine complexities perfectly. Essential for transplant surgery training applications.",
      rating: 5
    },
    {
      name: "Dr. Bailey",
      role: "Consultant Clinical Neurophysiologist",
      content: "The diagnostic expertise and multidisciplinary collaboration focus was outstanding. Perfect for neurophysiology consultant posts.",
      rating: 5
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 3) % testimonials.length);
    }, 6000); // Change testimonials every 6 seconds

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const toggleFAQ = (index: number) => {
    setExpandedFAQ(expandedFAQ === index ? null : index);
  };

  return (
    <div className="relative overflow-hidden min-h-screen bg-white">
      {/* Arka Plan Efektleri */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none">
        <div className="absolute top-[-5%] right-[-5%] w-[600px] h-[600px] bg-blue-50 rounded-full blur-[120px] opacity-60"></div>
        <div className="absolute bottom-[-10%] left-[-10%] w-[500px] h-[500px] bg-emerald-50 rounded-full blur-[100px] opacity-40"></div>
      </div>

      <div className="relative z-10 container mx-auto px-6 pt-24 pb-32">
        {/* Hero Section */}
        <header className="flex flex-col items-center text-center max-w-5xl mx-auto mb-32">
          <div className="mb-8 inline-flex items-center gap-3 bg-white px-5 py-2.5 rounded-full border border-slate-100 shadow-xl shadow-slate-100/50 animate-in fade-in slide-in-from-top-4 duration-1000">
            <span className="flex h-2.5 w-2.5 relative">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-blue-600"></span>
            </span>
            <span className="text-[10px] font-black text-slate-500 uppercase tracking-[0.25em]">
              NHS INTERVIEW PREPARATION 2024/25
            </span>
          </div>
          
          <h1 className="text-6xl md:text-8xl font-black text-slate-900 mb-8 tracking-tight leading-[0.95] animate-in fade-in slide-in-from-bottom-8 duration-700">
            Secure Your <span className="text-blue-600">NHS Post</span> <br className="hidden md:block" /> with AI Precision.
          </h1>
          
          <p className="text-xl md:text-2xl text-slate-500 max-w-3xl mb-14 leading-relaxed font-medium animate-in fade-in slide-in-from-bottom-10 duration-1000">
            The professional-grade platform for UK doctors. Map your portfolio to GMC standards using advanced RAG technology and real-world panel simulations.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 animate-in fade-in zoom-in duration-1000 delay-300">
            <button 
              onClick={onStart}
              className="group bg-slate-900 text-white px-12 py-6 rounded-[2rem] font-black text-xl shadow-2xl shadow-slate-300 hover:bg-blue-600 transition-all hover:-translate-y-1 active:scale-95 flex items-center gap-4"
            >
              Start Practice Session
              <svg className="group-hover:translate-x-2 transition-transform" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </button>
            <button 
              onClick={onBlog}
              className="group bg-white border-2 border-slate-200 text-slate-900 px-12 py-6 rounded-[2rem] font-black text-xl hover:border-blue-600 hover:text-blue-600 transition-all hover:-translate-y-1 active:scale-95 flex items-center gap-4"
            >
              Interview Blog
              <svg className="group-hover:translate-y-[-2px] transition-transform" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1-2.5-2.5Z"/><path d="M8 7h6"/><path d="M8 11h8"/><path d="M8 15h6"/></svg>
            </button>
          </div>
        </header>

        {/* How We Build Section */}
        <section className="mb-40" aria-labelledby="methodology-title">
          <div className="text-center mb-20">
            <h2 id="methodology-title" className="text-[10px] font-black text-blue-600 uppercase tracking-[0.4em] mb-4">Our Methodology</h2>
            <h3 className="text-4xl md:text-5xl font-black text-slate-900 tracking-tight">The 4-Pillar AI Coaching System</h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 relative">
            <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-slate-100 -translate-y-1/2 z-0"></div>
            
            {[
              {
                step: "01",
                title: "Job DNA Extraction",
                desc: "We analyze NHS Jobs / TRAC adverts to map specific Person Specifications and Trust Values.",
                icon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><path d="m8 3 4 8 5-5 5 15H2L8 3z"/></svg>
              },
              {
                step: "02",
                title: "Evidence Grounding",
                desc: "Your CV and portfolio are synchronized (RAG) to ground AI feedback in your actual clinical evidence.",
                icon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"/><path d="M16 16h5v5"/></svg>
              },
              {
                step: "03",
                title: "Real-time Hurdle Logic",
                desc: "AI simulated panels challenge you with follow-up 'hurdle' questions based on the ISC 4th Ed guidelines.",
                icon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              },
              {
                step: "04",
                title: "Professional Audit",
                desc: "Every answer is scored against GMC standards, the Francis Report, and NICE clinical excellence.",
                icon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
              }
            ].map((s, i) => (
              <article key={i} className="relative z-10 bg-white p-8 rounded-[2.5rem] border border-slate-100 shadow-xl shadow-slate-100/50 hover:border-blue-200 transition-all flex flex-col items-center text-center group">
                <div className="w-12 h-12 bg-blue-600 text-white rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-blue-100 group-hover:scale-110 transition-transform">
                  {s.icon}
                </div>
                <span className="text-[10px] font-black text-blue-600 mb-2 uppercase tracking-widest">{s.step}</span>
                <h4 className="text-xl font-black text-slate-800 mb-3">{s.title}</h4>
                <p className="text-slate-500 text-xs font-medium leading-relaxed">{s.desc}</p>
              </article>
            ))}
          </div>
        </section>

        {/* Blog Preview Section - SEO Internal Linking */}
        <section className="mb-40 max-w-6xl mx-auto" aria-labelledby="blog-preview-title">
          <div className="text-center mb-16">
            <h2 id="blog-preview-title" className="text-[10px] font-black text-blue-600 uppercase tracking-[0.4em] mb-4">Latest Insights</h2>
            <h3 className="text-3xl md:text-4xl font-black text-slate-900 tracking-tight">Interview Preparation Insights</h3>
            <p className="text-slate-500 mt-4 max-w-2xl mx-auto">Expert analysis and strategies to help you excel in your NHS medical interviews</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Blog Preview 1 */}
            <article className="group bg-white p-8 rounded-[2rem] border border-slate-100 shadow-lg hover:shadow-xl hover:border-blue-200 transition-all cursor-pointer" onClick={() => window.open('/blog/interviewers-looking-for', '_blank')}>
              <div className="flex items-center gap-3 mb-4">
                <span className="bg-purple-100 text-purple-600 px-3 py-1 rounded-full text-xs font-bold">Interview Insights</span>
                <span className="text-slate-400 text-xs">Jan 02, 2025</span>
              </div>
              <h4 className="text-xl font-black text-slate-800 mb-3 group-hover:text-blue-600 transition-colors">What Interviewers Are Really Looking For: The Three Core Selection Questions</h4>
              <p className="text-slate-500 text-sm leading-relaxed mb-4">Medical interviews can feel overwhelming, but beneath the complexity lies a simple framework. Learn the three core questions that drive every selection decision.</p>
              <div className="flex items-center justify-between">
                <span className="text-xs font-bold text-slate-600">Medical Interview Team</span>
                <span className="text-blue-600 font-bold text-sm group-hover:translate-x-2 transition-transform">Read More →</span>
              </div>
            </article>

            {/* Blog Preview 2 */}
            <article className="group bg-white p-8 rounded-[2rem] border border-slate-100 shadow-lg hover:shadow-xl hover:border-blue-200 transition-all cursor-pointer" onClick={() => window.open('/blog/nhs-interview-structure', '_blank')}>
              <div className="flex items-center gap-3 mb-4">
                <span className="bg-green-100 text-green-600 px-3 py-1 rounded-full text-xs font-bold">Interview Preparation</span>
                <span className="text-slate-400 text-xs">Dec 28, 2024</span>
              </div>
              <h4 className="text-xl font-black text-slate-800 mb-3 group-hover:text-blue-600 transition-colors">NHS Interview Structure: Stations, Formats, and What to Expect</h4>
              <p className="text-slate-500 text-sm leading-relaxed mb-4">Master the NHS interview structure with detailed insights into formal and practical stations, from portfolio reviews to clinical governance.</p>
              <div className="flex items-center justify-between">
                <span className="text-xs font-bold text-slate-600">NHS Interview Team</span>
                <span className="text-blue-600 font-bold text-sm group-hover:translate-x-2 transition-transform">Read More →</span>
              </div>
            </article>

            {/* Blog Preview 3 */}
            <article className="group bg-white p-8 rounded-[2rem] border border-slate-100 shadow-lg hover:shadow-xl hover:border-blue-200 transition-all cursor-pointer" onClick={() => window.open('/blog/medical-interviews-structured-selection', '_blank')}>
              <div className="flex items-center gap-3 mb-4">
                <span className="bg-emerald-100 text-emerald-600 px-3 py-1 rounded-full text-xs font-bold">Interview Insights</span>
                <span className="text-slate-400 text-xs">Dec 30, 2024</span>
              </div>
              <h4 className="text-xl font-black text-slate-800 mb-3 group-hover:text-blue-600 transition-colors">How Medical Interviews Really Work: Understanding Structured Selection</h4>
              <p className="text-slate-500 text-sm leading-relaxed mb-4">Medical interviews have evolved from casual conversations to highly structured assessments requiring deliberate preparation and self-awareness.</p>
              <div className="flex items-center justify-between">
                <span className="text-xs font-bold text-slate-600">Dr. James Mitchell</span>
                <span className="text-blue-600 font-bold text-sm group-hover:translate-x-2 transition-transform">Read More →</span>
              </div>
            </article>
          </div>

          <div className="text-center mt-12">
            <button
              onClick={onBlog}
              className="group bg-blue-600 text-white px-8 py-4 rounded-2xl font-bold text-lg hover:bg-blue-700 transition-all shadow-lg hover:shadow-xl active:scale-95 flex items-center gap-3 mx-auto"
            >
              View All Articles
              <svg className="group-hover:translate-x-2 transition-transform" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </button>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="mb-40 max-w-6xl mx-auto" aria-labelledby="testimonials-title">
          <div className="text-center mb-16">
            <h2 id="testimonials-title" className="text-[10px] font-black text-blue-600 uppercase tracking-[0.4em] mb-4">Success Stories</h2>
            <h3 className="text-3xl md:text-4xl font-black text-slate-900 tracking-tight">What Our Users Say</h3>
            <p className="text-slate-500 mt-4 max-w-2xl mx-auto">Real feedback from doctors who secured their NHS posts using our AI-powered preparation platform</p>
          </div>

          <div className="relative bg-white p-8 md:p-12 rounded-[3rem] border border-slate-100 shadow-2xl shadow-slate-100/50 overflow-hidden">
            {/* Testimonials Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {testimonials.slice(currentTestimonial, currentTestimonial + 3).map((testimonial, index) => (
                <div key={currentTestimonial + index} className="text-center p-6 rounded-2xl bg-slate-50 hover:bg-slate-100 transition-all duration-300">
                  <div className="flex justify-center mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <svg key={i} className="w-4 h-4 text-yellow-400 fill-current" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                  </div>
                  <blockquote className="text-sm text-slate-700 font-medium leading-relaxed mb-6">
                    "{testimonial.content}"
                  </blockquote>
                  <div className="text-center">
                    <div className="font-bold text-slate-900 text-sm">{testimonial.name}</div>
                    <div className="text-slate-500 text-xs font-medium">{testimonial.role}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* SEO FAQ Section */}
        <section className="mb-40 max-w-4xl mx-auto" aria-labelledby="faq-title">
          <div className="text-center mb-16">
            <h2 id="faq-title" className="text-3xl md:text-4xl font-black text-slate-900">Medical Interview FAQs</h2>
          </div>
          <div className="space-y-4">
            {[
              {
                q: "What is the CAMP framework in NHS interviews?",
                a: "CAMP stands for Clinical, Academic, Management, and Personal. It is the gold-standard structure for answering 'Tell me about yourself' or 'Why should we hire you?' questions in UK medical interviews."
              },
              {
                q: "How does the AI score clinical governance questions?",
                a: "Our AI uses the CARE framework (Clinical Effectiveness, Audit, Risk Management, Education) and cross-references your answers with GMC Good Medical Practice and the Francis Report's Duty of Candour."
              },
              {
                q: "Is this platform suitable for ST1 or Consultant interviews?",
                a: "Yes. Our engine adjusts its logic based on the target grade. ST1 candidates are scored on potential and safety, while Consultant candidates are audited on leadership, service development, and strategic governance."
              },
              {
                q: "How should I prepare for portfolio-based questions?",
                a: "Focus on demonstrating GMC standards through real examples. Use the STAR technique (Situation, Task, Action, Result) to structure responses. Highlight achievements in clinical effectiveness, audit, risk management, and teaching."
              },
              {
                q: "What are the most common pitfalls in NHS interviews?",
                a: "Candidates often fail to provide specific examples, talk too generally about 'teamwork' without evidence, or don't address safety concerns proactively. Avoid generic answers - panels want to see your personal involvement in real clinical scenarios."
              },
              {
                q: "How does the platform handle specialty-specific questions?",
                a: "The AI adapts questions based on your chosen specialty and grade. For example, surgical candidates get technical questions, while psychiatry candidates focus on communication and mental health law. All questions align with relevant specialty curricula."
              },
              {
                q: "What makes this different from generic interview prep apps?",
                a: "Unlike generic apps, this platform uses NHS-specific frameworks (ISC Medical, GMC standards) and adapts to your portfolio via RAG technology. Questions are generated based on real job descriptions and include specialty-specific clinical scenarios."
              },
              {
                q: "How do I demonstrate leadership in medical interviews?",
                a: "Show evidence of leading change, managing teams, or improving services. Use examples from audit projects, quality improvement initiatives, or teaching junior colleagues. Quantify your impact with measurable outcomes."
              },
              {
                q: "What should I do if I'm asked about a clinical mistake?",
                a: "Use the 'reflective practitioner' approach: Acknowledge the error, explain what you learned, and describe how you've changed practice. Focus on patient safety improvements and demonstrate insight rather than defensiveness."
              },
              {
                q: "How important are NHS values in the interview?",
                a: "Extremely important. Every answer should demonstrate the 6Cs (Care, Compassion, Competence, Communication, Courage, Commitment) and address 'working together for patients'. Panels look for cultural fit with NHS values."
              },
              {
                q: "Should I prepare answers for ethical dilemmas?",
                a: "Yes, ethical scenarios are common. Use the 4-box approach: Medical indications, patient preferences, quality of life, and contextual features. Reference GMC guidance and show balanced decision-making."
              },
              {
                q: "How do I handle questions about my weaknesses?",
                a: "Choose a genuine weakness with a positive spin. Show self-awareness, describe improvement actions, and demonstrate growth. Avoid clichés like 'I'm a perfectionist' - be authentic and show reflective practice."
              }
            ].map((faq, i) => (
              <div key={i} className="bg-white rounded-[2rem] border border-slate-100 shadow-sm overflow-hidden">
                <button
                  onClick={() => toggleFAQ(i)}
                  className="w-full p-8 text-left hover:bg-slate-50 transition-colors flex items-center justify-between group"
                >
                  <h4 className="text-lg font-black text-slate-800 pr-4">{faq.q}</h4>
                  <svg
                    className={`w-6 h-6 text-slate-400 group-hover:text-blue-600 transition-transform flex-shrink-0 ${expandedFAQ === i ? 'rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${expandedFAQ === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
                  <div className="px-8 pb-8">
                    <p className="text-slate-500 text-sm leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Trust Signals */}
        <footer className="mt-32 pt-20 border-t border-slate-100 flex flex-col items-center">
          <p className="text-[10px] font-black text-slate-300 uppercase tracking-[0.4em] mb-16 text-center">Referencing Professional UK Medical Standards</p>
          <div className="flex flex-wrap justify-center items-center gap-x-16 gap-y-12 opacity-40 grayscale hover:grayscale-0 transition-all duration-700">
            <div className="flex flex-col items-center">
              <span className="text-2xl font-black text-slate-800 tracking-tighter italic">GMC Standards</span>
            </div>
            <div className="flex flex-col items-center">
              <span className="text-3xl font-black text-blue-900 tracking-tighter">NHS Values</span>
            </div>
            <div className="flex flex-col items-center">
              <span className="text-2xl font-black text-emerald-800 tracking-tighter italic">NICE Guidance</span>
            </div>
            <div className="flex flex-col items-center">
              <span className="text-2xl font-black text-slate-800 tracking-tighter">ISC Medical</span>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Landing;
